export default "__VITE_ASSET__aWsr$Kjr__"